function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M193.21 177.205l-1.047 2.167v-1.356c.355-.268.703-.539 1.046-.811z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.163 149.044l2.77-.029v30.357c-18.494 14.692-51.205 23.008-73.32 22.492-22.116-.516-55.153-7.8-73.555-22.492v-28.819h2.77v27.466c16.244 12.313 46.028 20.498 70.849 21.078 22.918.535 53.482-8.2 70.486-21.08v-28.973z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.786 177.209l1.042 2.163v-1.353a52.48 52.48 0 01-1.042-.81z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.786 177.209l1.042 2.163v-1.353a52.48 52.48 0 01-1.042-.81z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.677 199.097c22.918.535 53.482-8.2 70.486-21.08v-28.973l2.77-.029v30.357c-18.494 14.692-51.205 23.008-73.32 22.492-22.116-.516-55.153-7.8-73.555-22.492v-28.819h2.77v27.466c16.244 12.313 46.028 20.498 70.849 21.078z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.21 177.205l-1.047 2.167v-1.356c.355-.268.703-.539 1.046-.811z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(161.595 175.45)",
  fill: "#9575CD"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.528 10.19l3.75 2.691C4.218 22.714 3.11 33.847 7.99 46.557L3.68 48.21C-1.737 34.094-.467 21.328 7.529 10.19zm10.632-.126l4.601.357c-1.164 15.006 3.228 22.863 13.2 24.574l-.781 4.548c-12.67-2.175-18.35-12.336-17.02-29.479z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.255 13.73l4.165 1.988c-4.753 9.955-4.033 19.382 2.19 28.603l-3.827 2.58c-7.134-10.573-7.987-21.737-2.528-33.17z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.34 11.1l4.493 1.051c-3.384 14.458-1.088 23.22 6.527 26.987l-2.048 4.135c-9.92-4.907-12.79-15.864-8.973-32.172z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.22,
  cy: 9.519,
  rx: 9.156,
  ry: 9.292
})), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#9575CD",
  cx: 122.13,
  cy: 118.603,
  rx: 20.523,
  ry: 6.359
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.387 189.766h-7.384v-39.964c.115-.662.129-1.101.04-1.319-.169-.241-.871-.83-2.052-1.575l-49.23-25.367 3.384-6.562 49.5 25.507.127.079c2.135 1.33 3.616 2.575 4.502 3.954 1.012 1.577 1.325 3.485 1.113 5.678v39.57z",
  fill: "#9575CD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.93 76.768L4.5 119.026l.026 2.752 115.402 47.01 115.246-47.017.08-2.995L119.93 76.768zm-84.71 93.909l74.284 38.556a13.975 13.975 0 017.523 11.772l.19 4.207a7.584 7.584 0 01-10.66 7.272L23.907 195.7c-7.052-3.138-10.224-11.399-7.085-18.45l.001-.003.076-.162c2.996-6.727 10.877-9.751 17.604-6.755.242.108.482.223.717.346z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.922 216.19a13.832 13.832 0 00-4.915-8.284c-6.005-4.86-14.862-3.877-19.783 2.198-4.92 6.075-4.042 14.94 1.963 19.8 6.005 4.862 14.862 3.878 19.783-2.197",
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.965 209.432l13.994 6.143c7.057-7.948 14.267-11.556 21.627-10.824 4.8.985-22.662-11.137-82.385-36.367-10.567-.168-17.08 3.857-19.542 12.075.464.138 12.686 5.462 36.667 15.97",
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.153 196.166c1.52 4.397-2.19 10.561-4.722 14.945a15.79 15.79 0 01-14.515 7.91c.954 1.408 2.408 2.404 4.452 2.744 5.545.923 5.18-.486 6.234.335 1.102 1.626-3.723 3.587-3.632 3.68 1.57 1.627 6.37 1.955 8.551 1.858 5.185-.232 9.948-3.665 12.758-8.533 4.355-7.543 1.84-17.147-5.616-21.452a15.453 15.453 0 00-3.51-1.487z",
  fill: "#9575CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.664 219.059c6.58 3.495 4.488-10.74 5.014-17.325.33-4.141 3.445-9.377 15.257-10.52.834-.081-5.396-4.096-7.202-4.948-1.302-.614-3.852-1.406-5.108-1.649-7.492-1.451-13.943 3.846-16.447 10.836-1.798 5.02-1.102 6.976-1.323 11.07-.125 2.31.567 4.264-1.12 6.462-2.698 3.516 7.665 4.62 10.929 6.074z",
  fill: "#9575CD"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(50 -170.316 107.863)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(50 -171.105 117.369)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(50 -169.695 181.982)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(50 -171.394 127.947)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(50 -169.984 192.56)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(50 -170.611 138.025)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(50 -169.2 202.638)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))));

function SvgEducationXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEducationXl;